import React, { useEffect } from "react";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  Grid,
  Tab,
  Tabs,
  Typography,
  IconButton,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import MailOutlineIcon from "@mui/icons-material/MailOutline";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import LockIcon from "@mui/icons-material/Lock";
import PersonIcon from "@mui/icons-material/Person";
import ChangePassword from "./ChangePassword";
import { useDispatch, useSelector } from "react-redux";
import { getUserProfileDetail } from "store/actions";
import { useState } from "react";
import { EditProfileModal } from "./EditProfileModal";
import moment from "moment";
import { getInitials } from "utils/constants";

export default function UserProfile() {
  const [tabIndex, setTabIndex] = useState(0);
  const [userDetails, setUserDetails] = useState();
  const handleTabChange = (event, newValue) => setTabIndex(newValue);
  const dispatch = useDispatch();
  const userData = useSelector((state) => state?.admin?.userInfo);
  const [editOpen, setEditOpen] = useState(false);

  useEffect(() => {
    if (userData) {
      getUser();
    }
  }, []);

  const getUser = async () => {
    const payload = { userId: userData?.userId ? userData?.userId : userData?._id };
    dispatch(
      getUserProfileDetail(payload, (result) => {
        if (result) {
          setUserDetails(result);
        }
      })
    );
  };

  return (
    <Box sx={{ p: 3 }}>
      {/* Tabs */}
      <Tabs value={tabIndex} onChange={handleTabChange} sx={{ mb: 2 }}>
        <Tab label="Profile" icon={<PersonIcon />} iconPosition="start" />
        <Tab label="Change Password" icon={<LockIcon />} iconPosition="start" />
      </Tabs>

      <Grid container spacing={2}>
        {tabIndex === 0 && (
          <>
            <Grid item xs={12} md={4}>
              <Card sx={{ textAlign: "center", p: 4 }}>
                <Avatar
                  src={userDetails?.profileImage?.signedUrl || undefined}
                  sx={{ width: 100, height: 100, mx: "auto", fontSize: 36 }}
                >
                  {!userDetails?.profileImage?.signedUrl && getInitials(userDetails?.name)}
                </Avatar>
                <Typography variant="h6" sx={{ mt: 1 }}>
                  {userDetails?.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {userDetails?.role}
                </Typography>
                <CardContent sx={{ mt: 2 }}>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <MailOutlineIcon sx={{ mr: 1 }} />
                    <Typography variant="body2">
                      {userDetails?.email}
                    </Typography>
                  </Box>
                  <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                    <PhoneIphoneIcon sx={{ mr: 1 }} />
                    <Typography variant="body2">
                      {userDetails?.mobileNumber}
                    </Typography>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item xs={12} md={8}>
              <Card>
                <CardContent>
                  <Box
                    sx={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <Typography variant="h6">About me</Typography>
                    <IconButton>
                      <EditIcon onClick={() => setEditOpen(true)} />
                    </IconButton>
                  </Box>
                  <Typography variant="h6" sx={{ mt: 1, mb: 2, fontWeight: 600,fontSize:16 }}>
                    {userDetails?.about}
                  </Typography>

                  <Typography variant="subtitle1" sx={{ mb: 1 }}>
                    Personal Details
                  </Typography>
                  {[
                    ["Full Name", userDetails?.name],
                    ["Phone", userDetails?.mobileNumber],
                    ["Email", userDetails?.email],
                    // ["Gender", userDetails?.gender],
                    ["Date of Birth", moment(userDetails?.dateOfBirth).format("MM-DD-YYYY")],
                    ["Website", userDetails?.website],
                  ].map(([label, value]) => (
                    <Box key={label} sx={{ display: "flex", mb: 1 }}>
                      <Box sx={{ width: 150, fontWeight: 600 }}>{label}</Box>
                      <Box sx={{ mr: 1 }}>:</Box>
                      <Typography variant="body2">{value}</Typography>
                    </Box>
                  ))}
                </CardContent>
              </Card>
            </Grid>
          </>
        )}
        {tabIndex === 1 && <ChangePassword />}
      </Grid>
      <EditProfileModal
        open={editOpen}
        onClose={() => setEditOpen(false)}
        initialValues={{
          mobileNumber: userDetails?.mobileNumber || "",
          about: userDetails?.about || "",
          website: userDetails?.website || "",
          gender: userDetails?.gender || "",
          dateOfBirth: userDetails?.dateOfBirth || "",
          profileImage: userDetails?.profileImage?.signedUrl,
          name: userDetails?.name
        }}
        userId={userData?.userId}
        getUser={getUser}
      />
    </Box>
  );
}
